import axios from "axios";
import queryStr from "qs";

//refresh token api calling
export const RefreshTokenFunc = async () => {
  var currentTime = new Date();
  let ParseTimer = sessionStorage.getItem("timer");
  let timer = new Date(ParseTimer);
  if (timer) {
    if (timer > currentTime) {
    } else {
      if (
        sessionStorage.getItem("access_token") &&
        sessionStorage.getItem("refresh_token")
      ) {
        const finaldata = await axios(
          `${process.env.REACT_APP_SITE_PRODUCTION_URL + "greenAuthtoken"}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "access-control-allow-origin": "*",
              authorization: "Bearer " + sessionStorage.getItem("access_token"),
            },
            data: queryStr.stringify({
              client_secret: window.btoa(process.env.REACT_APP_CLIENT_SECRET),
              client_id: window.btoa(process.env.REACT_APP_CLIENT_ID),
              grant_type: "refresh_token",
              refresh_token: sessionStorage.getItem("refresh_token"),
            }),
          }
        );

        sessionStorage.setItem("access_token", finaldata.data.access_token);
        sessionStorage.setItem("expires_in", finaldata.data.expires_in);
        sessionStorage.setItem("refresh_token", finaldata.data.refresh_token);

        //timer
        var d1 = new Date(),
          d2 = new Date(d1);
        let mintToAdd = parseInt(Number(finaldata.data.expires_in) / 60) - 5;
        d2.setMinutes(d1.getMinutes() + mintToAdd);

        sessionStorage.setItem("timer", d2);
      }
    }
  }
};
